/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    IdentitySettingsFormConfiguration,
    IdentitySettingsFormConfigurationFromJSON,
    IdentitySettingsFormConfigurationToJSON,
    IdentitySettingsFormData,
    IdentitySettingsFormDataFromJSON,
    IdentitySettingsFormDataToJSON,
    IdentitySettingsValidationData,
    IdentitySettingsValidationDataFromJSON,
    IdentitySettingsValidationDataToJSON,
} from '../models';

export interface ApiIdentitySettingsIdentitySettingsFormCreatePostRequest {
    identitySettingsFormData?: IdentitySettingsFormData;
}

export interface ApiIdentitySettingsIdentitySettingsFormDataGetRequest {
    id?: string;
}

export interface ApiIdentitySettingsIdentitySettingsFormIdDeleteRequest {
    id: string;
}

export interface ApiIdentitySettingsIdentitySettingsFormUpdatePostRequest {
    identitySettingsFormData?: IdentitySettingsFormData;
}

export interface ApiIdentitySettingsIdentitySettingsFormValidatePostRequest {
    identitySettingsFormData?: IdentitySettingsFormData;
}

/**
 * no description
 */
export class IdentitySettingsFormApi extends runtime.BaseAPI {

    /**
     */
    async apiIdentitySettingsIdentitySettingsFormConfigurationGetRaw(): Promise<runtime.ApiResponse<IdentitySettingsFormConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/IdentitySettings/IdentitySettingsForm/Configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => IdentitySettingsFormConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiIdentitySettingsIdentitySettingsFormConfigurationGet(): Promise<IdentitySettingsFormConfiguration> {
        const response = await this.apiIdentitySettingsIdentitySettingsFormConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiIdentitySettingsIdentitySettingsFormCreatePostRaw(requestParameters: ApiIdentitySettingsIdentitySettingsFormCreatePostRequest): Promise<runtime.ApiResponse<string>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/IdentitySettings/IdentitySettingsForm/Create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IdentitySettingsFormDataToJSON(requestParameters.identitySettingsFormData),
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async apiIdentitySettingsIdentitySettingsFormCreatePost(requestParameters: ApiIdentitySettingsIdentitySettingsFormCreatePostRequest): Promise<string> {
        const response = await this.apiIdentitySettingsIdentitySettingsFormCreatePostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiIdentitySettingsIdentitySettingsFormDataGetRaw(requestParameters: ApiIdentitySettingsIdentitySettingsFormDataGetRequest): Promise<runtime.ApiResponse<IdentitySettingsFormData>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/IdentitySettings/IdentitySettingsForm/Data`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => IdentitySettingsFormDataFromJSON(jsonValue));
    }

    /**
     */
    async apiIdentitySettingsIdentitySettingsFormDataGet(requestParameters: ApiIdentitySettingsIdentitySettingsFormDataGetRequest): Promise<IdentitySettingsFormData> {
        const response = await this.apiIdentitySettingsIdentitySettingsFormDataGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiIdentitySettingsIdentitySettingsFormIdDeleteRaw(requestParameters: ApiIdentitySettingsIdentitySettingsFormIdDeleteRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiIdentitySettingsIdentitySettingsFormIdDelete.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/IdentitySettings/IdentitySettingsForm/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiIdentitySettingsIdentitySettingsFormIdDelete(requestParameters: ApiIdentitySettingsIdentitySettingsFormIdDeleteRequest): Promise<void> {
        await this.apiIdentitySettingsIdentitySettingsFormIdDeleteRaw(requestParameters);
    }

    /**
     */
    async apiIdentitySettingsIdentitySettingsFormUpdatePostRaw(requestParameters: ApiIdentitySettingsIdentitySettingsFormUpdatePostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/IdentitySettings/IdentitySettingsForm/Update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IdentitySettingsFormDataToJSON(requestParameters.identitySettingsFormData),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiIdentitySettingsIdentitySettingsFormUpdatePost(requestParameters: ApiIdentitySettingsIdentitySettingsFormUpdatePostRequest): Promise<void> {
        await this.apiIdentitySettingsIdentitySettingsFormUpdatePostRaw(requestParameters);
    }

    /**
     */
    async apiIdentitySettingsIdentitySettingsFormValidatePostRaw(requestParameters: ApiIdentitySettingsIdentitySettingsFormValidatePostRequest): Promise<runtime.ApiResponse<IdentitySettingsValidationData>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/IdentitySettings/IdentitySettingsForm/Validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IdentitySettingsFormDataToJSON(requestParameters.identitySettingsFormData),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => IdentitySettingsValidationDataFromJSON(jsonValue));
    }

    /**
     */
    async apiIdentitySettingsIdentitySettingsFormValidatePost(requestParameters: ApiIdentitySettingsIdentitySettingsFormValidatePostRequest): Promise<IdentitySettingsValidationData> {
        const response = await this.apiIdentitySettingsIdentitySettingsFormValidatePostRaw(requestParameters);
        return await response.value();
    }

}
